import React from 'react'
import { Privacy } from 'common/legal'

const PrivacyPolicy = () => <Privacy />

export default PrivacyPolicy
